<template>
<div class="eChart">
    <div class="title1">
      <span class="fl tip">成绩曲线</span>
      <div class="classSelect fr" v-if="echartData.length">
        <span class="selectActive" @click="selectShow">{{subjectName}}</span>
        <ul class="selectBox" v-if='subjectF'>
          <li v-for="(item, index) in subjectList" @click="changetype(item,index)">
            {{item}}
          </li>
        </ul>
      </div>
    </div>
    <noFound v-if="!echartData.length"></noFound>
    <div id="myChart" style="width: 100%; height: 330px;" :class="{noHeight: !echartData.length}"></div>
  </div>
</template>
<script>
import noFound from "./../noData/nodata.vue";
export default {
  props: ['echartData'],
  data() {
    return {
      subjectF: false,
      subjectName: '整体曲线',
      subjectList: ['整体曲线', '单词跟读', '课文跟读', '听说模考', '线上作答', '报听写']
    }
  },
  components: {
    noFound
  },
  watch: {
    echartData(curVal,oldVal){
      this.setOption(curVal)
    }
  },
  created() {
    this.$nextTick(() => {
      // this.drawLine([], [])
      // console.log(this.echartData, 'ghghg')
    })
  },
  methods: {
    setOption (curData) {
      let recordDate = []
      let sore = []
       curData.map((item, i) => {
         recordDate.push(item.recordDate)
         let s =  Math.floor(item.Sore.toFixed(2))
         sore.push(s)
       })
      console.log(recordDate, sore)
      this.drawLine(recordDate, sore)
    },
     drawLine(recordDate, sore) {
      let myChart = this.$echarts.init(document.getElementById('myChart'))
      myChart.setOption({
        tooltip: {
          show: true,
          textStyle: {
            fontStyle: 'oblique'
          }
        },
        noDataLoadingOption: {
          text: '暂无数据',
          effect: 'bubble',
          effectOption: {
            effect: {
              n: 0
            }
          }
        },
        xAxis: {
          type: 'category',
          axisLine: {
            /* 横轴的字体颜色 */
            show: true,
            lineStyle: {
              color: "#666"
            }
          },
          axisLabel: {
            /* 横轴刻度状态 */
            interval: 0,
            rotate: 30
          },
          data: recordDate
          // data: ['2018-08-01', '2018-08-12', '2018-08-13', '2018-08-14', '2018-08-15', '2018-08-16', '2018-08-17', '2018-08-18', '2018-08-19', '2018-08-20', '2018-08-21', '2018-08-22', '2018-08-23', '2018-08-24', '2018-08-25', '2018-08-26', '2018-08-27', '2018-08-28', '2018-08-29']
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          data: sore,
          label: {
            normal: {
              show: true,
              position: 'top'
            }
          },
          type: 'line',
          itemStyle: {
            /* 设置线的颜色 */
            normal: {
              color: "green",
              lineStyle: {
                color: "green"
              }
            }
          },
        }]
      });
    },
    changetype (data, i) {
      this.subjectName = data
      this.subjectF = false
      this.$emit('setsoreType', i)
    },
    selectShow () {
      this.subjectF = true
    }
  }
};
</script>



// WEBPACK FOOTER //
// echartLine.vue?1feb9952